<div class="ng-footer">
  <div>&copy; {{currentYear}} EZI BUS Version : {{version}}</div>
</div>
